import { Pipe, PipeTransform } from '@angular/core';

import {RequestedArgumentModel} from '@app/core/model/integration-models';
import {DatePipe} from '@angular/common';
import {FiltersListService} from '@app/views/admin/application-settings/components/filters/filters-list-wrapper/filters-list.service';
import {GradeMap} from '@app/core/model/grade.map';

@Pipe({
    name: 'ngcSuggestion'
})
export class SuggestionPipe implements PipeTransform {

    constructor (private datePipe: DatePipe) {
    }

    transform(argument: RequestedArgumentModel, propertyName: string, dateFormat: string = 'shortDate'): string {
        const value = argument.name;

        if (!argument.isDate) {
            return this.transformString(value, propertyName);
        }

        if (argument.isDate && !argument.isDateBetween) {
            return this.transformDate(value, dateFormat);
        }

        if (argument.isDateBetween) {
            return this.transformDateBetween(value, dateFormat);
        }
    }

    transformString(value: string, propertyName: string): string {
        const isGrade = FiltersListService.checkIsGradeSelected(propertyName);
        const isSchoolId = FiltersListService.checkIsSchoolIdSelected(propertyName);

        if (isGrade) {
            return this.transformGrade(value);
        }

        if (isSchoolId) {
            return this.transformSchoolId(value);
        }

        return value;
    }

    transformGrade(value: string): string {
        return GradeMap.get(value) ? GradeMap.get(value) : value;
    }

    transformSchoolId(value: string): string {
        const school = RequestedArgumentModel.getSchoolObjFromSchoolNameAndLocalId(value);
        return school && school.localId ? `${school.schoolName} [SIS ID: ${school.localId}]` : value;
    }

    transformDateBetween(value: string, dateFormat?: string): string {
        const colonIndex = value.indexOf(':');
        const startDate = new Date(value.substring(0, colonIndex) + 'T00:00:00');
        const endDate = new Date(value.substring(colonIndex + 1) + 'T00:00:00');

        return this.datePipe.transform(startDate, dateFormat) + ' - ' + this.datePipe.transform(endDate, dateFormat);
    }

    transformDate(value: string, dateFormat?: string): string {
        return this.datePipe.transform(value, dateFormat);
    }
}
